import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.sass';

import { initializeLogger, logger } from './utils/logger';
import { telegramApi } from './utils/telegramApi';

// Условная загрузка Eruda для development
if (import.meta.env.MODE === 'development') {
  const script = document.createElement('script');
  script.src = '//cdn.jsdelivr.net/npm/eruda';
  script.onload = () => {
    (window as any).eruda?.init();
  };
  document.head.appendChild(script);
}

// Инициализируем логгер только в продакшн-сборке
if (import.meta.env.MODE === 'production') {
  initializeLogger();
}

// Инициализируем Telegram API
telegramApi.initApp().catch(error => {
  logger.error('Ошибка инициализации Telegram API:', error);
});

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);
root.render(<App />);
